import "./dom_extend";
import { Animation } from "./animations";

let ajaxFormInstances = new WeakMap();

export class AjaxForm {
	constructor(form) {
		this.form = form;
		this.alert = null;

		this.options = {
			successMessage: this.form.getAttribute("data-success-message") || "Record has been successfully saved.",
			hideTimeout: this.form.getAttribute("data-af-hide-timeout") ? parseInt(this.form.getAttribute("data-af-hide-timeout")) : false,
			enableLogging: this.form.getAttribute("data-af-log-callback") == "true",
			success: null
		};

		this.build();
	}
	onRequest() {
		this.disableForm();
	}
	onResponse(status, data, responseText) {
		this.enableForm();

		if (status == 200) {
			this.success(data);
		}
		else if (status == 400 && data) {
			this.error(data);
		}
		else {
			this.serverError("Error " + status + ": " + responseText);
		}
	}
	onServerError(responseText) {
		this.enableForm();
		this.serverError(responseText);
	}
	//
	// Build form elements
	//
	build() {
		var self = this;

		var formGroups = this.form.querySelectorAll(".form-group");
		for (var i = 0; i < formGroups.length; ++i) {
			var formGroup = formGroups[i];
			var fieldName = formGroup.querySelector("[id][name]");
			var fieldNames = fieldName ? fieldName.getAttribute("name").match(/\[([a-zA-Z-_0-9]+)(\([a-zA-Z-_0-9]+\))?\]/) : null;
			var fieldId = fieldNames ? fieldNames[1] : null;
			if (fieldId) {
				formGroup.setAttribute("data-af-field", fieldId);
			}
		}
	}
	//
	// Form is valid
	//
	success(data) {
		var self = this;
		this.form.trigger("ajaxformsuccess", { form: this.form, data: data });

		Animation.fadeOut(this.form).then(function() {
			if (self.options.success) {
				self.options.success();
			}

			let successMessage = data && data.af && data.af.success_message ? data.af.success_message : self.options.successMessage;

			self.clearForm();
			self.showAlert("success", successMessage);
			self.alert.classList.add("d-none");

			Animation.fadeIn(self.alert).then(function() {
				if (self.options.hideTimeout) {
					setTimeout(function() {
						Animation.fadeOut(self.alert).then(function() {
							self.alert.remove();
							Animation.fadeIn(self.form);
						});
					}, self.options.hideTimeout * 1000);
				}
			});
		});
	}
	//
	// There were errors, form is not valid
	//
	error(errors) {
		// this.setFlashMessage(false);
		this.form.trigger("ajaxformerror", { form: this.form, errors: errors });

		// Set error messages
		for (var field in errors) {
			var errorMessages = errors[field];
			var formField = this.form.querySelector("[data-af-field='" + field + "']");
			if (formField) {
				// Fill form with error messages
				for (var i = 0; i < errorMessages.length; ++i) {
					var feedback = document.createElement("div");
					feedback.classList.add("invalid-feedback");
					feedback.innerText = errorMessages[i];
					formField.appendChild(feedback);
				}

				// Mark field as errorous
				formField.querySelector("[id][name]").classList.add("is-invalid");
			}
		}
	}
	//
	// There were communication error
	//
	serverError(error) {
		this.form.trigger("ajaxformerror", { form: this.form, error: error });
		this.showAlert("danger", error);
	}
	showAlert(kind, message) {
		if (this.alert) {
			this.alert.remove();
			this.alert = null;
		}

		this.alert = document.createElement("div");
		this.alert.classList.add("alert", "alert-" + kind);
		this.form.parentNode.insertBefore(this.alert, this.form);
		this.alert.innerHTML = message;
	}
	disableForm() {
	}
	enableForm() {
		this.clearErrors();
		if (this.clearCallback) {
			this.clearCallback();
		}
	}
	clearErrors() {
		var feedbacks = this.form.querySelectorAll(".invalid-feedback");
		for (var i = 0; i < feedbacks.length; ++i) {
			feedbacks[i].remove();
		}

		var invalids = this.form.querySelectorAll(".is-invalid");
		for (var i = 0; i < invalids.length; ++i) {
			invalids[i].classList.remove("is-invalid");
		}

		if (this.alert) {
			this.alert.remove();
			this.alert = null;
		}
	}
	clearForm() {
		this.clearErrors();

		if (this.options.clearOnSubmit) {
			var formControls = this.form.querySelectorAll(".form-control");
			for (var i = 0; i < formControls.length; ++i) {
				formControls[i].value = "";
			}
		}
	}
	static create(form) {
		return new AjaxForm(form);
	}
	static get(element) {
		var element = element.closest("form");
		if (!ajaxFormInstances.has(element)) {
			ajaxFormInstances.set(element, AjaxForm.create(element));
		}
		return ajaxFormInstances.get(element);
	}
}




// *************************************************************************
// Run
// *************************************************************************

document.addEventSelectorListener("ajaxbefore", "form[data-af]", function(event, target) {
	var ajaxForm = AjaxForm.get(target);
	ajaxForm.onRequest();
});

document.addEventSelectorListener("ajaxsuccess", "form[data-af]", function(event, target) {
	var ajaxForm = AjaxForm.get(target);
	ajaxForm.onResponse(
		event.detail.status,
		event.detail.responseJSON,
		event.detail.response
	);
});

document.addEventSelectorListener("ajaxerror", "form[data-af]", function(event, target) {
	var ajaxForm = AjaxForm.get(target);
	ajaxForm.onServerError("Nelze navázat spojení, jste připojeni k internetu?");
});
